import styled from 'styled-components';

import {
  Inputbox as commonInputbox,
  Input as commonInput,
} from '../../assets/Common/Inputbox.style';

export const Inputbox = styled.div`
  ${commonInputbox}

  .react-datepicker {
    display: flex;
    border-radius: 8px;
    border: 0;
    box-shadow: 0px 0px 15px 0px ${(props) => props.theme.popperShadow};
  }

  .react-datepicker-wrapper {
    width: 100%;
    height: 100%;
  }

  .react-datepicker-popper {
    z-index: 2;
    width: 100%;
  }

  .react-datepicker__triangle {
    &::before {
      border-top-color: ${(props) =>
        props.theme.popperTriangleBorder} !important;
    }
  }

  .react-datepicker__input-container {
    position: relative;
    display: block;
    width: 100%;
    background: transparent;
    border: 0;
    border-radius: 10px;

    input {
      ${commonInput}
    }
  }

  .react-datepicker__header {
    background: ${(props) => props.theme.popperHeaderBg};
    border: 1px solid ${(props) => props.theme.popperHeaderBorder};
    border-radius: 0;
    padding: 0;
  }

  .react-datepicker__month-container {
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
  }

  .react-datepicker__current-month {
    display: block;
    padding: 10px 10px 0 10px;
    color: ${(props) => props.theme.popperHeaderColor};
    font-size: 14px !important;
    line-height: 1.2;
    cursor: default;
  }

  .react-datepicker__navigation--previous {
    width: 10px;
    height: 10px;
    border: 8px solid transparent !important;
    border-right-color: ${(props) => props.theme.popperHeaderColor} !important;
  }

  .react-datepicker__navigation--next {
    width: 10px;
    height: 10px;
    border: 8px solid transparent !important;
    border-left-color: ${(props) => props.theme.popperHeaderColor} !important;
  }

  .react-datepicker__day-names {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
  }

  .react-datepicker__day-name {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px !important;
    height: 30px !important;
    margin: auto;
    color: ${(props) => props.theme.popperHeaderColor};
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
    cursor: default;
  }

  .react-datepicker__month {
    display: grid;
    margin: 0;
  }

  .react-datepicker__week {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
  }

  .react-datepicker__day {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 45px !important;
    height: 45px !important;
    margin: auto;
    color: ${(props) => props.theme.popperColor};
    font-size: 14px;
    font-weight: 400;
    line-height: 1.2;
    cursor: pointer;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background: ${(props) => props.theme.popperSelectedBg};
    color: ${(props) => props.theme.popperSelectedColor};
    font-weight: 400 !important;
    &:hover {
      background: ${(props) => props.theme.popperSelectedBg};
    }
  }

  .react-datepicker__day--disabled,
  .react-datepicker__day--keyboard-disabled {
    background: ${(props) => props.theme.popperDisabledBg};
    color: ${(props) => props.theme.popperDisabledColor};
    font-weight: 400 !important;
    &:hover {
      background: ${(props) => props.theme.popperDisabledBg};
    }
  }
`;

export const InputIcon = styled.i`
  position: absolute;
  top: 50%;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 67px;
  height: 67px;
  transform: translateY(-50%);
  transition: 0.2s all;
  color: ${(props) => props.theme.color};
  font-size: 24px;
  cursor: pointer;
  user-select: none;

  &:hover {
    color: ${(props) => props.theme.colorOnHover};
  }
`;
